import AsusTUFGamingA15 from "../assets/asus/AsusTUFGamingA15.jpg";

const asusProducts = [
  {
    id: 1,
    name: "Asus TUF Gaming A15",
    image: AsusTUFGamingA15,
    specs: [
      "AMD Ryzen 7 4800H processor",
      "Windows 11",
      "16GB RAM",
      "512GB SSD Nvme 4.0",
      "Nvidia Geforce RTX3050 4GB GPU",
      "15.6 144Hz FH Display",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in Asus TUF Gaming A15",
  },
];

export default asusProducts;
